import invert from 'lodash/invert';
import HttpService from '~/zf/frontend/common/http/HttpService';
import VcomProvider from '../../VcomProvider';
import { PerformanceOverviewEndpoint } from '../../common/endpoints/modules/portlets/PerformanceOverviewEndpoint';
import getColumnsDefinition from './components/columns';
import ColumnId from './const/ColumnId';

function getHiddenTodayColumns() {
  return [
    ColumnId.EPI,
    ColumnId.VFG,
  ];
}

function getOnlyTodayColumns() {
  return VcomProvider.isRegionChina
    ? []
    : [ColumnId.INVERTER_EVALUATION];
}

function prepareColumnsForBackend(selectedColumns) {
  const columns = getColumnsDefinition();

  const columnsFiltered = columns.filter(
    (column) => selectedColumns.includes(column.colId),
  );
  return columnsFiltered.map((column) => ({
    data: column.field,
    name: column.field,
    orderable: true,
    search: {
      value: '',
    },
  }));
}

function getSortModel(order) {
  if (order.length === 0) {
    return [{
      column: 'bezeichnung',
      dir: 'asc',
    }];
  }
  const [sortModel] = order;

  return [{
    column: invert(ColumnId)[sortModel.colId],
    dir: sortModel.sort,
  }];
}

async function load(
  timeRange,
  paginationPageSize,
  start,
  order,
  selectedEndDate,
  selectedStartDate,
  selectedColumns,
) {
  const response = await HttpService.post(PerformanceOverviewEndpoint.GET, {
    systemId: VcomProvider.systemId,
    date: timeRange,
    columns: prepareColumnsForBackend(selectedColumns),
    order: getSortModel(order),
    start,
    selectedDate: selectedEndDate,
    customStartDate: selectedStartDate,
    customEndDate: selectedEndDate,
    length: paginationPageSize,
  });
  return response.data;
}

async function savePaginationSize(pageSize, portletUId) {
  return HttpService.post(PerformanceOverviewEndpoint.SAVE_PAGINATION_SIZE, {
    pageSize,
    portletUId,
  });
}

async function getColumnConfiguration(portletUId) {
  const response = await HttpService.post(PerformanceOverviewEndpoint.GET_COLUMNS, { portletUId });
  return response.data;
}

function getColumns(columnIds) {
  const columnsDefinition = getColumnsDefinition();
  return columnIds.map((columnId) => columnsDefinition.find(
    (columnDefinition) => ColumnId[columnDefinition.field] === columnId,
  ));
}

const PerformanceOverviewService = {
  getHiddenTodayColumns,
  getColumnConfiguration,
  getOnlyTodayColumns,
  load,
  savePaginationSize,
  getColumns,
};

export default PerformanceOverviewService;
